function RecipeCard({ recipe }) {
    return (
      <div className="bg-white rounded-2xl shadow-lg hover:shadow-xl transition-all transform hover:-translate-y-1 flex flex-col overflow-hidden border border-gray-100">
        <div className="relative h-48">
          <img 
            src={recipe.imageUrl || "https://via.placeholder.com/300x200"} 
            alt={recipe.title} 
            className="w-full h-full object-cover"
          />
          <button className="absolute top-3 right-3 bg-white rounded-full p-1.5 shadow-md hover:shadow-lg transition-all">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" style={{ color: '#6c757d' }}>
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
            </svg>
          </button>
        </div>
        <div className="p-4 flex-grow flex flex-col">
          <h3 className="font-bold text-lg mb-1" style={{ color: '#2C3E50' }}>{recipe.title}</h3>
          <p className="text-sm mb-3 flex-grow" style={{ color: '#6c757d' }}>{recipe.description}</p>
          <div className="flex justify-between items-center mt-auto">
            <div className="flex items-center">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor" style={{ color: '#6c757d' }}>
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
              <span className="text-sm" style={{ color: '#6c757d' }}>{recipe.prepTime + recipe.cookTime} min</span>
            </div>
            <button 
              className="text-white text-sm py-2 px-4 rounded-full font-medium hover:opacity-90 transition-all"
              style={{ backgroundColor: '#87A96B' }}
            >
              Ajouter au menu
            </button>
          </div>
        </div>
      </div>
    );
  }
  
  export default RecipeCard;